import React, { useState, useEffect } from "react";
import {
  Phone,
  MessageCircle,
  Wifi,
  Car,
  Utensils,
  Waves,
  TreePine,
  Coffee,
  Bath,
  Tv,
  Wind,
  MapPin,
  PartyPopper,
  Users,
  PawPrint,
  Calendar,
  Home,
  Camera,
  Gamepad2,
  ChevronRight,
  Sparkles,
  Flower2,
  Leaf,
  Wine,
  CircleQuestionMark,
} from "lucide-react";

import { useTranslation } from "react-i18next";

import theme from "../theme";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=B%26B%20Ligo%2C%20Ligo%2C%20Villanova%20d%27Albenga";

// Footer Component
const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer
      className="py-12"
      style={{ backgroundColor: theme.moss, color: theme.cream }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h3 className="text-2xl font-bold mb-2">B&amp;B Ligo</h3>
          <p className="mb-6 opacity-80">
            Bed &amp; Breakfast - Liguria, Italia
          </p>
          <div className="flex justify-center gap-4 mb-8">
            <a
              href={`tel:${t("callPhoneNumber")}`}
              className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
              style={{ backgroundColor: "rgba(255,255,255,0.1)" }}
              aria-label="Call us"
              title="Call us"
            >
              <Phone size={20} />
            </a>
            <a
              href={`https://wa.me/${t("whatsappPhoneNumber")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
              style={{ backgroundColor: "rgba(255,255,255,0.1)" }}
              aria-label="Chat on WhatsApp"
              title="Chat on WhatsApp"
            >
              <MessageCircle size={20} />
            </a>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
              style={{ backgroundColor: "rgba(255,255,255,0.1)" }}
              aria-label="Open in Google Maps"
              title="Open in Google Maps"
            >
              <MapPin size={20} />
            </a>
          </div>
          <p className="text-sm opacity-60">
            © 2025 B&amp;B Ligo. Tutti i diritti riservati. | Sito realizzato da{" "}
            <a
              href="https://angelogerminario.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Angelo Germinario
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
